
    import './styles.scoped.css';
    export default {
  "input-adorned-container": "awsui_input-adorned-container_2rhyz_1q53f_9",
  "input": "awsui_input_2rhyz_1q53f_9",
  "input-adorned-container-readonly": "awsui_input-adorned-container-readonly_2rhyz_1q53f_22",
  "input-readonly": "awsui_input-readonly_2rhyz_1q53f_22",
  "root": "awsui_root_2rhyz_1q53f_35",
  "input-invalid": "awsui_input-invalid_2rhyz_1q53f_138",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_1q53f_147",
  "input-warning": "awsui_input-warning_2rhyz_1q53f_150",
  "input-type-search": "awsui_input-type-search_2rhyz_1q53f_162",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_1q53f_175",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_1q53f_178",
  "grouped": "awsui_grouped_2rhyz_1q53f_185",
  "grouped-first": "awsui_grouped-first_2rhyz_1q53f_185",
  "grouped-middle": "awsui_grouped-middle_2rhyz_1q53f_191",
  "grouped-last": "awsui_grouped-last_2rhyz_1q53f_197",
  "grouped-only": "awsui_grouped-only_2rhyz_1q53f_203",
  "input-container": "awsui_input-container_2rhyz_1q53f_210",
  "input-icon-start": "awsui_input-icon-start_2rhyz_1q53f_215",
  "input-icon-end": "awsui_input-icon-end_2rhyz_1q53f_222",
  "input-button-right": "awsui_input-button-right_2rhyz_1q53f_228",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_1q53f_232",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_1q53f_235",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_1q53f_239",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_1q53f_242",
  "inline-label": "awsui_inline-label_2rhyz_1q53f_232",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_1q53f_267",
  "input-adorned-container-disabled": "awsui_input-adorned-container-disabled_2rhyz_1q53f_292",
  "input-adorned-container-invalid": "awsui_input-adorned-container-invalid_2rhyz_1q53f_300",
  "input-adorned-container-warning": "awsui_input-adorned-container-warning_2rhyz_1q53f_313",
  "input-prefix": "awsui_input-prefix_2rhyz_1q53f_327",
  "input-suffix": "awsui_input-suffix_2rhyz_1q53f_328",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_1q53f_341",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_1q53f_350",
  "input-adorned": "awsui_input-adorned_2rhyz_1q53f_9"
};
  